var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.9993,
    height: 20,
    rx: 9.99967,
    fill: "#FFF9EF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 0C4.47701 0 0 4.47733 0 10C0 10.1339 0.00263347 10.2673 0.00785145 10.3999C0.217779 5.06265 4.61095 0.799867 9.99967 0.799867C15.3884 0.799867 19.7816 5.06265 19.9915 10.3999C19.9967 10.2673 19.9993 10.1339 19.9993 10C19.9993 4.47733 15.5223 0 9.99967 0Z",
    fill: "white",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0003 19.9999C15.523 19.9999 20 15.5226 20 9.99994C20 9.866 19.9974 9.73267 19.9921 9.6C19.7822 14.9373 15.389 19.2001 10.0003 19.2001C4.61161 19.2001 0.218443 14.9373 0.00850387 9.60003C0.00328726 9.73268 0.000653199 9.866 0.000653187 9.99994C0.000652705 15.5226 4.47766 19.9999 10.0003 19.9999Z",
    fill: "#030303",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6405 13.9196L15.5983 13.8721L14.5107 14.9264L14.5371 14.9528L14.8222 15.2375C15.0017 15.422 15.3924 15.3323 15.6933 15.0371C15.9943 14.7419 16.0893 14.3571 15.9098 14.1726L15.6405 13.9038V13.9196Z",
    fill: "#82BFAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3342 13.6138L14.252 14.6786L14.5106 14.9422L15.5982 13.8721L15.5665 13.8404L15.3342 13.6138Z",
    fill: "#AAD4C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66403 4.66804C8.99864 4.6512 8.3387 4.79163 7.738 5.07786C7.1373 5.3641 6.61286 5.78804 6.20743 6.31512C5.80201 6.8422 5.52708 7.45749 5.40507 8.11083C5.28305 8.76416 5.31741 9.43704 5.50534 10.0746C5.69327 10.7122 6.02944 11.2963 6.48645 11.7795C6.94346 12.2627 7.50837 12.6312 8.13511 12.8549C8.76184 13.0787 9.43267 13.1513 10.0929 13.067C10.7531 12.9827 11.384 12.7438 11.9342 12.3697L14.2518 14.6839L15.3077 13.6296L13.0112 11.3365C13.4678 10.7145 13.7437 9.9788 13.8085 9.21032C13.8733 8.44185 13.7245 7.67041 13.3784 6.98096C13.0324 6.29151 12.5025 5.71077 11.8471 5.30269C11.1918 4.8946 10.4363 4.67499 9.66403 4.66804ZM9.66403 11.8109C9.07932 11.8057 8.50931 11.6275 8.02605 11.2988C7.5428 10.97 7.16802 10.5056 6.9491 9.96426C6.73018 9.42287 6.67695 8.82883 6.79614 8.25724C6.91534 7.68565 7.20161 7.16218 7.61874 6.75304C8.03588 6.3439 8.56516 6.06746 9.13964 5.95867C9.71413 5.84987 10.308 5.91362 10.8462 6.14185C11.3844 6.37007 11.8428 6.75253 12.1633 7.24085C12.4838 7.72917 12.6521 8.30142 12.6469 8.88525C12.6434 9.27292 12.5636 9.65612 12.4118 10.013C12.26 10.3698 12.0393 10.6933 11.7623 10.965C11.4853 11.2366 11.1575 11.4512 10.7974 11.5963C10.4374 11.7415 10.0523 11.8144 9.66403 11.8109Z",
    fill: "#616E7D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3692 6.90844C10.9897 6.57417 10.5025 6.3871 9.99652 6.38129L9.96484 8.32647L11.3692 6.90844Z",
    fill: "#82BFAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62156 6.34967C9.29585 6.34956 8.97342 6.41459 8.67329 6.54092C8.37316 6.66725 8.10141 6.85232 7.87407 7.08521C7.64673 7.31811 7.46841 7.5941 7.34962 7.89693C7.23084 8.19975 7.174 8.52326 7.18246 8.84836C7.17681 9.51255 7.43458 10.152 7.89948 10.6271C8.36439 11.1021 8.99865 11.3742 9.66379 11.384C10.1202 11.3941 10.5704 11.2778 10.9646 11.048C11.3588 10.8181 11.6815 10.4837 11.897 10.0819L9.66379 8.88527V6.34967H9.62156Z",
    fill: "#AAD4C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7517 9.08026L11.2796 7.43555L10.9154 7.80982L10.5405 8.96428L10.7517 9.08026Z",
    fill: "#AAD4C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4768 8.93268L10.8041 7.91528L10.4398 8.28956L10.2656 8.81671L10.4768 8.93268Z",
    fill: "#AAD4C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5647 9.5231L12.0926 7.90475C12.0519 7.79892 12.0025 7.69665 11.9448 7.599L11.3535 9.4124L11.5647 9.5231Z",
    fill: "#AAD4C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8391 9.67599L12.2351 8.44773C12.213 8.29903 12.1777 8.1526 12.1295 8.01019L11.6279 9.56002L11.8391 9.67599Z",
    fill: "#AAD4C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0238 9.77614C12.1839 9.44827 12.2618 9.08645 12.2508 8.72184V8.62695L11.9023 9.70761L12.0238 9.77614Z",
    fill: "#AAD4C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8096 9.11718L11.0207 9.22788L11.6701 7.21944L11.5856 7.12982L11.3903 7.33014L10.8096 9.11718Z",
    fill: "#AAD4C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3294 8.39502L10.0391 8.69595L10.208 8.7857L10.3294 8.39502Z",
    fill: "#AAD4C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2952 9.37547L11.8917 7.5199C11.8406 7.44394 11.7842 7.37171 11.7228 7.30377L11.084 9.26477L11.2952 9.37547Z",
    fill: "#AAD4C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchicon);
export default __webpack_public_path__ + "static/media/research icon.746072d3abff5fb8345fead87e6861a7.svg";
export { ForwardRef as ReactComponent };